@use "../../../node_modules/@thelabnyc/breakpoint-sass/stylesheets/breakpoint";
@use "../../styles/layout";

.container {
    gap: 100px 2rem;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin-bottom: 100px;

    @include breakpoint.breakpoint(layout.$belowMedium) {
        grid-template-columns: 1fr;
    }

    /* stylelint-disable-next-line selector-class-pattern */
    & :global(.rich-text) {
        @include breakpoint.breakpoint(layout.$belowMedium) {
            padding: 26px 10% 0;
        }
    }
}
